module.exports = __webpack_public_path__ + "static/img/vip_btn.e59eaf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/member/vip_btn.jpg
// module id = +ZW6
// module chunks = 1